import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TractorsEnginePowerPerHectareWidgetComponent } from './tractors-engine-power-per-hectare-widget.component';
import {DxChartModule} from 'devextreme-angular';



@NgModule({
  declarations: [TractorsEnginePowerPerHectareWidgetComponent],
  imports: [
    CommonModule,
    DxChartModule
  ],
  exports: [TractorsEnginePowerPerHectareWidgetComponent]
})
export class TractorsEnginePowerPerHectareWidgetModule { }
